import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LoginService } from '../../../services/auth';
import { usePortalStore } from '../../../stores/portalStore';
import { JWTHelper } from '../../../services/auth/JWTHelper';
// import { UserHelper } from '../../../services/auth/UserHelper';
import { StorageHelper } from '../../../services/auth/StorageHelper';
// import { DecodedToken } from '../../../types/auth/DecodedToken';

export const PrivateRoute = () => {
    const loginService = LoginService;
    const setCurrentUser = usePortalStore((state: any) => state.setCurrentUser);

    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);
    //const [isMFAValidation, setIsMFAValidation] = useState(false); //
    const [isLoggedSkipMfa, setIsLoggedSkipMFA] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const isLogged = loginService.isLogged();
            if (isLogged) {
                const user = loginService.currentUser();
                // setIsMFAValidation(false);
                setIsLoggedSkipMFA(true);
                setCurrentUser(user);
                setAuthorized(true);
                setLoading(false);
                return;
            }

            console.warn('[Auth] ⚠️ Nenhum usuário logado no storage — tentando SSO cookie...');
            /**
             * O SSO consiste nas etapas:
             * 1. Clique no botão com um texto similar a esse: "Acessar com sua conta White Martins"
             * 2. Ao clicar é direcionado a lambda da AWS em ${variavel_aws_url}/sso/login?redirect=main
             * 3. O backend (backend/lambdas/sso/login.ts) faz o SAML(autenticação Single Sign On) e redireciona para o outra lambda (backend/lambdas/sso/acs)
             * 4. O backend (backend/lambdas/sso/acs) busca o usuario, se loga no cognito com o email que recebeu da Azure Ad (ssoToken) e desafio(challenge) e gera um token valido (token)
             * 5. O backend (backend/lambdas/sso/acs) redireciona para o frontend (frontend/src/pages/sso/callback.js)
             * 5. O frontend (frontend/src/pages/sso/callback.js) seta o cookie com o token do backend, token do cognito e o desafio MFA - se tiver, e redireciona para essa rota
             * 5.1 Se o MFA com cognito estiver desabilitado faz o login porque não é token de desafio MFA, é token cognito real
             * 5.2 Se o MFA estiver habilitado recebe um token válido para um desafio(challengeLoginMFAFromCookie = "SMS")
             * 6. Abaixo setamos os dados de usuario na sessão do sessionStorage e no amplify(cognito)
             */
            const tokenFromCookie = localStorage.getItem('idToken') || JWTHelper.getSSOIdTokenFromStorage();
            const tokenFromCookieIsExpired = JWTHelper.isExpired(tokenFromCookie || undefined);
            const hasValidToken = tokenFromCookie && !tokenFromCookieIsExpired;
            const idTokenCognitoFromCookie = JWTHelper.getSSOIdTokenFromStorage();
            const ssoChallengeDeviceFromCookie = JWTHelper.getSSOChallengeDeviceFromStorage();
            const ssoChallengeSessionFromCookie = JWTHelper.getSSOChallengeSessionFromStorage();
            const isSSOAuth = Boolean(idTokenCognitoFromCookie);
            // const isSSOAuthChallenge = Boolean(ssoChallengeDeviceFromCookie && ssoChallengeSessionFromCookie);

            try {
                if (hasValidToken) {
                    console.log('hasValidToken', hasValidToken)
                    const userFromToken = JWTHelper.decode(tokenFromCookie);
                    // Se não tem desafio MFA, ou seja MFA desabilitado, recebe login real
                    if (isSSOAuth) {
                        console.log('isSSOAuth', isSSOAuth)
                        if (userFromToken) {
                            console.log('userFromToken', userFromToken)
                            const ssoSession = await LoginService.createSSOSession(userFromToken, idTokenCognitoFromCookie); // MFA Desabilitado recebe token real do cognito via lambda acs
                            // `userFromToken` são as claims cruas do JWT (`custom:isAdmin`, `custom:isManager`, ...).
                            // A store espera o formato normalizado (`isAdmin`, `isManager`, ...), então usamos o
                            // usuário devolvido por createSSOSession — caso contrário todas as permissões viram
                            // `false` até o primeiro refresh da página.
                            const ssoUser = ssoSession?.user || loginService.currentUser();
                            if (!ssoUser?.name) {
                                console.error('[Auth] Não foi possível montar a sessão SSO: ', ssoSession?.status);
                                setAuthorized(false);
                                setLoading(false);
                                return;
                            }
                            //setIsMFAValidation(false);
                            setIsLoggedSkipMFA(true);
                            setCurrentUser(ssoUser);
                            setAuthorized(true);
                        }
                    }
                    // if (isSSOAuthChallenge) {
                    //   // verify
                    //   // Passo pra completar desafio MFA, por email ou por SMS, o padrão visto que MFA está habilitado no cognito
                    //   setIsMFAValidation(true);
                    //   setAuthorized(false);
                    // }
                    setLoading(false);
                } else {
                    console.error('O token do cookie está expirado ou é invalido: ', tokenFromCookie);
                    console.warn('[Auth] Nenhum token válido encontrado. Redirecionando para /login...');
                    setAuthorized(false);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Ocorreu um erro na etapa do SSO no front:: ', error);
                setAuthorized(false);
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    if (loading) {
        return <div>Carregando autenticação segura...</div>;
    }

    /*if (isMFAValidation) {
      return <Navigate to="/verify" />;
    }*/
    // if(isLoggedSkipMfa) {
    //   return <Navigate to="/orders" />;
    // }

    if (!authorized) {
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};
